"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var TableMenuIsLocked_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var BrandPayoutList = /** @class */ (function (_super) {
    __extends(BrandPayoutList, _super);
    function BrandPayoutList(props) {
        return _super.call(this, props) || this;
    }
    BrandPayoutList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    BrandPayoutList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandPayoutList.prototype.doDefaultAction = function (Key, Title, isLocked) {
        var _this = this;
        this.props.data.DoSetIsLocked(Key, isLocked, function () {
            if (isLocked) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0422\u0438\u043F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0431\u0440\u0435\u043D\u0434\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0431\u044B\u043B \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0422\u0438\u043F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0431\u0440\u0435\u043D\u0434\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0431\u044B\u043B \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    BrandPayoutList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Бренд',
                dataIndex: this.props.data.dk_app_payout_id,
                key: this.props.data.dk_app_payout_id,
                width: 200,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "registered" }),
                        " ",
                        _this.props.rootRecord.title);
                }
            }, {
                title: 'Тип выплаты',
                dataIndex: this.props.data.dk_app_payout_title,
                key: this.props.data.dk_app_payout_title,
                width: 120,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        record.app_payout_title,
                        " ",
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "credit-card" })));
                }
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                width: 120,
                render: function (text, record, index) {
                    return (React.createElement("div", null, record.app_currency_title));
                }
            }, {
                title: 'Процент комиссии',
                dataIndex: this.props.data.dk_comission_percent_x100,
                key: this.props.data.dk_comission_percent_x100,
                width: 120,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        record.comission_percent_x100.toFixed(0),
                        "% "));
                }
            }, {
                title: 'Фикс. комиссия',
                dataIndex: this.props.data.dk_comission_fixed_amount,
                key: this.props.data.dk_comission_fixed_amount,
                width: 120,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        record.comission_fixed_amount.toFixed(2),
                        " ",
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "coin" })));
                }
            }, {
                title: 'Сумма Мин/Макс',
                dataIndex: this.props.data.dk_min_amount,
                key: this.props.data.dk_min_amount,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.min_amount.toFixed(2),
                        "/",
                        record.max_amount.toFixed(2)));
                }
            }, {
                title: 'Шлюз',
                dataIndex: this.props.data.dk_gateway,
                key: this.props.data.dk_gateway,
                width: 120,
                render: function (text, record, idx) {
                    if (record.is_dynamic_gateway) {
                        return (React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439")));
                    }
                    else {
                        return (React.createElement("div", null, record.gateway));
                    }
                }
            }, {
                title: 'Regexp аккаунта',
                dataIndex: this.props.data.dk_account_regex_js,
                key: this.props.data.dk_account_regex_js,
                width: 200,
                render: function (text, record, idx) {
                    if (record.is_use_account_regex_js) {
                        return (React.createElement("div", null, record.account_regex_js));
                    }
                    else {
                        return (React.createElement("div", null, "\u043D\u0435\u0442"));
                    }
                }
            }, {
                title: 'Заблокирована',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать", text: "Да" }, unlockedTexts: { menu: "Разблокировать", text: "Нет" }, record: { key: record.key, title: record.app_payout_title, locked: record.is_locked }, onLockClick: _this.doDefaultAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditDataClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 100
            }
        ]);
    };
    BrandPayoutList.prototype.onEditDataClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandPayoutList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0422\u0438\u043F \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0431\u0440\u0435\u043D\u0434\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.app_payout_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandPayoutList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BrandPayoutList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0428\u0430\u0431\u043B\u043E\u043D JSON:"),
                        " [",
                        record.json_tpl,
                        "]"),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u041F\u0440\u0438\u043C\u0435\u0440 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430:"),
                        " [",
                        record.account_example,
                        "]")); }, scroll: { x: true } })));
    };
    return BrandPayoutList;
}(React.Component));
exports.default = BrandPayoutList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/payout_pp/BrandPayoutList.tsx
// module id = 1782
// module chunks = 0